import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import Header from './components/Header';
import LandingPage from './components/LandingPage';
import Dashboard from './components/Dashboard';
import CountyMapView from './components/CountyMapView';
import SearchPage from './components/SearchPage';
import TankAI from './components/TankAI';
import Settings from './components/Settings';
import { ThemeProvider } from './contexts/ThemeContext';
import logger from './services/logger';
import './App.css';

function App() {
  const { isLoading, user, isAuthenticated } = useAuth0();

  useEffect(() => {
    // Remove continuous logging - only log critical events
    console.log('Storage Tank Platform application started');
  }, []);

  useEffect(() => {
    if (isAuthenticated && user) {
      logger.setUserId(user.sub || 'unknown');
      // Only log authentication once, not continuously
      console.log('User authenticated:', user.email);
    }
  }, [isAuthenticated, user]);

  if (isLoading) {
    return (
      <div className="loading-container">
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/county-map" element={<CountyMapView />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/tank-ai" element={<TankAI />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </main>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;